import { createApp } from "vue";
import App from "./App.vue";
import { store } from "./store";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import { vfmPlugin } from "vue-final-modal";
import VueNumberInput from "@chenfengyuan/vue-number-input";
import router from "@/router";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import i18n from "@/i18n";
import "vue-multiselect/dist/vue-multiselect.css";
import { realtimeClientMixin } from "./mixins/realtime_client";
import "./registerServiceWorker";

const permissionMixin = {
  methods: {
    can: (key) => store.getters["permissions/getAll"].includes(key),
    enablePlayerStateModal(flight) {
      return (
        this.$root.can("states:manage") && flight.timeSheetType != "TOURNAMENT"
      );
    },
    enableHoleSettingsModal() {
      return (
        this.can("flightOvertakes:manage") ||
        this.can("refereeDecisions:manage") ||
        this.can("offsets:manage")
      );
    },
  },
};

const userInfoMixin = {
  methods: {
    userInfo: () => store.getters["permissions/getPermissionTokenPayload"],
  },
};

const app = createApp({
  extends: App,
  mixins: [permissionMixin, userInfoMixin, realtimeClientMixin],
});

app.use(i18n);
app.use(Toast, {});
app.use(router);
app.use(store);
app.use(
  vfmPlugin({
    key: "$vfm",
    componentName: "VueFinalModal",
    dynamicContainerName: "ModalsContainer",
  })
);

app.component(VueNumberInput.name, VueNumberInput);

app.mount("#app");
